module.exports = __webpack_public_path__ + "img/组 4.37155920.webp";